import React, {useState, useCallback} from 'react';
import {Button} from "@mui/material";
import classNames from "classnames";
import {NotificationManager} from "react-notifications";


export const OriginalQuizQuestions = ({
                                          questionList,
                                          disabled,
                                          onChangeQuestion
                                      }) => {


    const onSelectAnswer = (qIndex, oId) => {
        let answerOptions = questionList[qIndex].answerOptionId;
        if (!answerOptions) answerOptions = [];
        if (typeof answerOptions === 'string') {
            answerOptions = [answerOptions];
        }
        const i = answerOptions.indexOf(oId);
        if (i === -1) {
            answerOptions.push(oId);
        } else {
            answerOptions.splice(i, 1);
        }
        questionList[qIndex].answerOptionId = answerOptions;
        onChangeQuestion(questionList);
    }

    const renderQuestion = (question, questionIndex) => {
        return (
            <div className={'quiz-question-item'} key={questionIndex}>
                <div className={'quiz-title'}>
                    {/*<div>{question.question} </div>*/}
                    <div dangerouslySetInnerHTML={{__html: question.question}}/>
                </div>
                {
                    (question.isAnnotation && question.answerAnnotationCorrect !== undefined) &&
                    <div className={'fs-15 text-lightyellow ps-2'}>{question.answerAnnotationCorrect ? 'Correct' : 'Incorrect'}</div>
                }
                <div className={'quiz-option-list'}>
                    {
                        question.optionList.map((option, optionIndex) => (
                            <div key={option.id}>
                                <Button
                                    className={classNames('quiz-option', {'selected': question.answerOptionId && question.answerOptionId.includes(option.id)}, {'truth': question.truthOptionId && question.truthOptionId.includes(option.id)})}
                                    disabled={disabled}
                                    onClick={() => onSelectAnswer(questionIndex, option.id)}
                                >
                                    <div dangerouslySetInnerHTML={{__html: option.value}}/>
                                </Button>
                                {
                                    (question.truthOptionId && question.truthOptionId.includes(option.id) && option.matchPercent !== undefined) &&
                                    <div className={'quiz-percent'}>{option.matchPercent}% of users chose this answer</div>
                                }
                            </div>
                        ))
                    }
                </div>
                {
                    question.questionExplain &&
                    <div className={'quiz-explain'}>
                        <div dangerouslySetInnerHTML={{__html: question.questionExplain}}/>
                    </div>
                }
            </div>
        )
    }

    return (
        <div className={'quiz-question-container'}>
            {questionList.map((v, i) => renderQuestion(v, i))}
        </div>
    );
};
